import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // localStorage for web
import { persistReducer, persistStore } from 'redux-persist';

import appReducer from '../slices/appSlice';
import authReducer from '../slices/authSlice';
import subscriptionReducer from '../slices/fundingSubscriptionSlice';
import mainTabReducer from '../slices/tabsSlice'
import weeklyReportDatesReducer from '../slices/weeklyReportDatesSlice';

// combine reducers
const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  subscription: subscriptionReducer,
  mainTab: mainTabReducer,
  weeklyReportDates: weeklyReportDatesReducer
});

// config for persistence
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['subscription'] // only persist subscription slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// create store
export const store = configureStore({
  reducer: persistedReducer
});

// persistor object
export const persistor = persistStore(store);
